<template>
  <el-dialog :title="opts.title || '批量设置'" :visible.sync="dialogVisible" width="600px" @close="handleClose">
    <div class="dialog-body">
      <div class="row">
        <el-radio v-model="form.mode" label="add">添加</el-radio>
        <el-input v-model="form.addPrefix" :disabled="form.mode !== 'add'" placeholder="前缀" class="w-180 mrg-l-10"></el-input>
        <span class="mid-label">原标题</span>
        <el-input v-model="form.addSuffix" :disabled="form.mode !== 'add'" placeholder="后缀" class="w-180"></el-input>
      </div>

      <div class="row">
        <el-radio v-model="form.mode" label="replace">替换</el-radio>
        <el-input v-model="form.replaceFrom" :disabled="form.mode !== 'replace'" class="w-180 mrg-l-10"></el-input>
        <span class="mid-label">替换为</span>
        <el-input v-model="form.replaceTo" :disabled="form.mode !== 'replace'" class="w-180"></el-input> 
      </div>

      <div class="row">
        <el-radio v-model="form.mode" label="delete">删除</el-radio>
        <el-select v-model="form.delete.type" :disabled="form.mode !== 'delete'" class="w-120 mrg-l-10">
          <el-option label="文本匹配" value="text"></el-option>
          <el-option label="模式匹配" value="pattern"></el-option>
        </el-select>
        <template v-if="form.delete.type === 'text'">
          <el-input v-model="form.delete.keyword" :disabled="form.mode !== 'delete'" class="mrg-l-10" placeholder="请输入要删除的关键词" style="width: 292px;"></el-input>
        </template>
        <template v-else>
          <el-select v-model="form.delete.pattern.symbol" :disabled="form.mode !== 'delete'" class="mrg-l-10" style="width: 102px;"> 
            <el-option label="（）" value="（）"></el-option>
            <el-option label="{}" value="{}"></el-option>
            <el-option label="「」" value="「」"></el-option>
          </el-select>
          <el-select v-model="form.delete.pattern.content" :disabled="form.mode !== 'delete'" class="w-180 mrg-l-10">
            <el-option label="任意文本" value="any"></el-option>
            <el-option label="任意字母" value="letters"></el-option>
            <el-option label="任意数字" value="numbers"></el-option>
            <el-option label="任意中文" value="chinese"></el-option>
          </el-select>
        </template>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      opts: {},
      form: {
        mode: 'add',
        addPrefix: '',
        addSuffix: '',
        replaceFrom: '',
        replaceTo: '',
        delete: {
          type: 'text',
          keyword: '',
          pattern: {
            symbol: '（）',
            content: 'any',
          },
        },
      },
    };
  },

  methods: {
    method_open(opts = {}) {
      this.dialogVisible = true;
      this.$set(this, 'opts', opts);
    },
    sure() {
      const specification = this.opts.specification || [];
      specification.forEach(item => {
        if(item.nameKey === this.opts.nameKey) {
          item.values.forEach(valueItem => {
            valueItem.value = this.applyFormula(valueItem.value);
          })
        }
      })
      this.opts.sureFn && this.opts.sureFn(specification);
      this.handleClose();
    },

    handleClose() {
      this.dialogVisible = false;
      Object.assign(this.$data, this.$options.data());
    },
    applyFormula(text) {
      const m = this.form.mode;
      if (m === 'add') {
        const prefix = this.form.addPrefix || '';
        const suffix = this.form.addSuffix || '';
        return prefix + text + suffix;
      }
      if (m === 'replace') {
        const from = this.form.replaceFrom || '';
        const to = this.form.replaceTo || '';
        if (!from) return text;
        const reg = new RegExp(this.escapeRegExp(from), 'g');
        return text.replace(reg, to);
      }
      if (m === 'delete') {
        if (this.form.delete.type === 'text') {
          const kw = this.form.delete.keyword || '';
          if (!kw) return text;
          const reg = new RegExp(this.escapeRegExp(kw), 'g');
          return text.replace(reg, '');
        } else {
          const { symbol, content } = this.form.delete.pattern;
          const r = this.buildPatternRegex(symbol);
          if (!r) return text;
          if (content === 'any') {
            return String(text).replace(r, '');
          }
          const charR = this.buildContentRegex(content);
          if (!charR) return text;
          return String(text).replace(r, (match) => match.replace(charR, ''));
        }
      }

      return text;
    },
    escapeRegExp(s) {
      return s.replace(/[.*+?^${}（）|[\]\\]/g, '\\$&');
    },
    buildPatternRegex(symbol) {
      const map = {
        '（）': { l: '\\（', r: '\\）', stop: '[^）]*' },
        '{}': { l: '\\{', r: '\\}', stop: '[^}]*' },
        '「」': { l: '「', r: '」', stop: '[^」]*' },
      };
      const cfg = map[symbol];
      if (!cfg) return null;
      return new RegExp(`${cfg.l}${cfg.stop}${cfg.r}`, 'g');
    },
    buildContentRegex(content) {
      if (content === 'letters') return /[A-Za-z]/g;
      if (content === 'numbers') return /[0-9]/g;
      if (content === 'chinese') return /[\u4e00-\u9fa5]/g;
      return null;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.dialog-body {
  padding: 10px 20px 0 20px;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.mid-label {
  color: #606266;
  margin: 0 10px;
}
.w-180 {
  width: 180px;
}
.w-120 {
  width: 120px;
}
.w-160 {
  width: 160px;
}
.mrg-l-10 { margin-left: 10px; }
</style>
